/// <amd-module name="SuiteCommerce.StockNotifications.Subscription.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Subscription.Model", ["require", "exports", "Backbone", "SuiteCommerce.StockNotifications.Utils", "SuiteCommerce.StockNotifications.Subscription.Configuration"], function (require, exports, Backbone_1, Utils_1, Subscription_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SubscriptionModel = void 0;
    var SubscriptionModel = /** @class */ (function (_super) {
        __extends(SubscriptionModel, _super);
        function SubscriptionModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.bulkCancelAll = true;
            _this.allGroupItemsIds = [];
            _this.allGroupSubscriptions = [];
            return _this;
        }
        Object.defineProperty(SubscriptionModel.prototype, "urlRoot", {
            get: function () {
                return Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Subscription.Service.ss'));
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "validation", {
            get: function () {
                return {
                    email: {
                        required: true,
                        msg: Utils_1.Utils.translate('Email is required'),
                        pattern: 'email'
                    },
                    firstname: {
                        required: Subscription_Configuration_1.SubscriptionConfiguration.isMandatoryName,
                        msg: Utils_1.Utils.translate('First Name is required')
                    },
                    lastname: {
                        required: Subscription_Configuration_1.SubscriptionConfiguration.isMandatoryLastName,
                        msg: Utils_1.Utils.translate('Last Name is required')
                    }
                };
            },
            enumerable: false,
            configurable: true
        });
        SubscriptionModel.prototype.unsubscribe = function () {
            return this.save();
        };
        Object.defineProperty(SubscriptionModel.prototype, "matrixParent", {
            get: function () {
                return this.get('matrixparent');
            },
            set: function (matrixParent) {
                this.set('matrixparent', matrixParent);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "itemId", {
            get: function () {
                return this.get('item');
            },
            set: function (itemId) {
                this.set('item', itemId);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "parentId", {
            get: function () {
                return this.get('matrixParentId') || this.itemId;
            },
            set: function (parentId) {
                this.set('matrixParentId', parentId);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "hasChildren", {
            get: function () {
                return this.get('hasChildren') || false;
            },
            set: function (hasChildren) {
                this.set('hasChildren', hasChildren);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isLastOfGroup", {
            get: function () {
                return this.get('isLastOfGroup') || false;
            },
            set: function (isLastOfGroup) {
                this.set('isLastOfGroup', isLastOfGroup);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isNotSubscribed", {
            get: function () {
                return this.get('isNotSubscribed') || false;
            },
            set: function (is) {
                this.set('isNotSubscribed', is);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isGroupVisible", {
            get: function () {
                return this.get('isGroupVisible') || false;
            },
            set: function (state) {
                this.set('isGroupVisible', state);
            },
            enumerable: false,
            configurable: true
        });
        SubscriptionModel.prototype.getAllGroupItemsIds = function () {
            return this.allGroupItemsIds;
        };
        SubscriptionModel.prototype.addItemIdToGroup = function (itemId) {
            this.allGroupItemsIds.push(itemId);
        };
        SubscriptionModel.prototype.getAllGroupSubscriptions = function () {
            return this.allGroupSubscriptions;
        };
        SubscriptionModel.prototype.setAllGroupSubscriptions = function (allSubscriptions) {
            this.allGroupSubscriptions = allSubscriptions;
        };
        SubscriptionModel.prototype.addSubscriptionToGroup = function (subscription) {
            this.allGroupSubscriptions.push(subscription);
        };
        Object.defineProperty(SubscriptionModel.prototype, "isDeletedSubscription", {
            get: function () {
                return this.get('isDeletedSubscription');
            },
            set: function (isDeleted) {
                this.set('isDeletedSubscription', isDeleted);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isInactive", {
            get: function () {
                return this.get('isinactive') === 'T';
            },
            set: function (isInactive) {
                if (isInactive) {
                    this.set('isinactive', 'T');
                }
                else {
                    this.set('isinactive', 'F');
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "idsToUnsubscribe", {
            get: function () {
                return this.get('idsToUnsubscribe');
            },
            set: function (ids) {
                this.set('idsToUnsubscribe', ids);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isBulk", {
            get: function () {
                return this.get('bulk') || false;
            },
            set: function (isBulk) {
                this.set('bulk', isBulk);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "isChild", {
            get: function () {
                return this.itemId !== this.parentId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SubscriptionModel.prototype, "subscribeToMails", {
            get: function () {
                return this.get('subscribeToMails') === 'T';
            },
            set: function (subscribeToMails) {
                if (subscribeToMails) {
                    this.set('subscribeToMails', 'T');
                }
                else {
                    this.set('subscribeToMails', 'F');
                }
            },
            enumerable: false,
            configurable: true
        });
        return SubscriptionModel;
    }(Backbone_1.Model));
    exports.SubscriptionModel = SubscriptionModel;
});
